import { MapperBase } from '../../utilities/mapper-base';
import { Briefcase } from '../ui/briefcase.model';
import { BriefcaseJobResource } from '../resource/briefcase-job.resource';

export class BriefcaseToBriefcaseJobResourceMapper extends MapperBase<Briefcase, BriefcaseJobResource> {
	map(source: Briefcase): BriefcaseJobResource {
		return {
			title: source.title,
			id: source.id,
			comments: source.comments,
			shouldShareBriefcase: source.isShared
		} as BriefcaseJobResource;
	}
}
